import React, { useState, useEffect, useRef } from "react";
import GYAxios from "../../../util/GYAxios";

const ReceiptTemplate_MSA = (props) => {
	const [PDF, setPDF] = useState(null);
	const pdfUrlRef = useRef(null);
	const lastRequestKeyRef = useRef("");
	const activeRequestIdRef = useRef(0);
	const debounceTimerRef = useRef(null);

	const previewStyle = {
		width: "100%",
		height: "72vh",
	};

	const fetchReceiptPDF = async ({
		invoiceNo,
		forcePaymentDate,
		requestId,
	}) => {
		const requestBody = { invoice_no: invoiceNo };
		if (forcePaymentDate) {
			requestBody.forcePaymentDate = forcePaymentDate;
		}

		const res = await GYAxios.post(
			"/receipts/generate/pdf",
			requestBody,
			{ responseType: "blob" },
		);

		if (requestId !== activeRequestIdRef.current) {
			return;
		}

		if (!(res?.data instanceof Blob)) {
			throw new Error("No PDF blob returned from server");
		}

		const contentDisposition = res?.headers?.["content-disposition"] || "";
		const matchedName = contentDisposition.match(/filename="?([^\";]+)"?/i);
		const fileName = matchedName?.[1] || `${invoiceNo}.pdf`;

		if (pdfUrlRef.current) {
			URL.revokeObjectURL(pdfUrlRef.current);
		}

		const dataUrl = URL.createObjectURL(res.data);
		pdfUrlRef.current = dataUrl;

		if (props.setPDFDoc != null) {
			props.setPDFDoc({
				type: "blob",
				blob: res.data,
				fileName,
			});
		}

		setPDF(dataUrl);
	};

	useEffect(() => {
		if (debounceTimerRef.current) {
			clearTimeout(debounceTimerRef.current);
			debounceTimerRef.current = null;
		}

		// Get invoice_no from props
		const invoiceNo = props.invoiceNo || props.receipt?.receipt?.invoice_no || props.receipt?.invoice?.invoice_no;
		// Get forcePaymentDate from props (optional)
		const forcePaymentDate = props.forcePaymentDate || null;

		if (!invoiceNo) {
			lastRequestKeyRef.current = "";
			setPDF(null);
			if (props.setPDFDoc != null) {
				props.setPDFDoc(null);
			}
			return;
		}

		const requestKey = `${invoiceNo}|${forcePaymentDate || ""}`;
		if (requestKey === lastRequestKeyRef.current) {
			return;
		}

		debounceTimerRef.current = setTimeout(() => {
			const requestId = activeRequestIdRef.current + 1;
			activeRequestIdRef.current = requestId;
			lastRequestKeyRef.current = requestKey;

			fetchReceiptPDF({
				invoiceNo,
				forcePaymentDate,
				requestId,
			}).catch(() => {
				if (requestId !== activeRequestIdRef.current) return;
				setPDF(null);
				if (props.setPDFDoc != null) {
					props.setPDFDoc(null);
				}
			});
		}, 200);

		return () => {
			if (debounceTimerRef.current) {
				clearTimeout(debounceTimerRef.current);
				debounceTimerRef.current = null;
			}
		};
	}, [props.invoiceNo, props.forcePaymentDate, props.receipt, props.setPDFDoc]);

	useEffect(() => {
		return () => {
			if (debounceTimerRef.current) {
				clearTimeout(debounceTimerRef.current);
				debounceTimerRef.current = null;
			}

			setPDF(null);
			if (pdfUrlRef.current) {
				URL.revokeObjectURL(pdfUrlRef.current);
				pdfUrlRef.current = null;
			}
		};
	}, []);

	return (
		<div>
			<iframe
				title="receipt-msa-preview"
				style={previewStyle}
				src={PDF || ""}
			/>
		</div>
	);
};

export default ReceiptTemplate_MSA;
